import Rpc from "@/Rpc";
import EventBus from "@/utils/EventBus";
import {getAvailableUserConnections} from "@/components/subscriptions/Subs";

export function onGoogleSignIn(googleUser){
    let profile = googleUser.getBasicProfile();
    console.log('ID: ' + profile.getId());
    console.log('Name: ' + profile.getName());
    console.log('Image URL: ' + profile.getImageUrl());
    console.log('Email: ' + profile.getEmail());

    let idToken = googleUser.getAuthResponse().id_token;
    console.log('ID Token: ' + idToken);


}

export function googleSignInEnabled() {
    return true;
}

export function googleSignIn(){
    const google = window['google'];

    const client = google.accounts.oauth2.initCodeClient({
        client_id: '602266346658-nael8ur3u7ui02nhtv5d8f7pdrh5ajkc.apps.googleusercontent.com',
        scope: 'openid email profile',
        ux_mode: 'popup',
        error_callback:(err)=>{
            console.error(err);
        },
        callback: (response) => {
            console.log(response);
            if(response.code){
                console.log(response.code);
                processGoogleCode(response.code).then();
            }
        },
    });
    client.requestCode();
}

async function processGoogleCode(code){
    let userData = await Rpc.Session.decodeGoogleId(code);
    if(userData.logged && userData.email){
        let servers = await getAvailableUserConnections(userData.email);
        EventBus.$emit(Events.googleSignIn, userData, servers);
    } else {
        EventBus.$emit(Events.googleSignInError, userData);
    }
}
window['onGoogleSignIn'] = onGoogleSignIn;
